import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/Users/UserDetail';
import FoodCategories from './pages/Foods/Categories';
import FoodItems from './pages/Foods/Items';
import FoodItemForm from './pages/Foods/ItemForm';
import Providers from './pages/Providers';
import SessionConfig from './pages/SessionConfig';
import Sessions from './pages/Sessions';


const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const AppRoutes: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/:id" element={<UserDetail />} />
        <Route path="foods/categories" element={<FoodCategories />} />
        <Route path="foods/items" element={<FoodItems />} />
        <Route path="foods/items/new" element={<FoodItemForm />} />
        <Route path="foods/items/:id" element={<FoodItemForm />} />
        <Route path="providers" element={<Providers />} />
        <Route path="session-config" element={<SessionConfig />} />
        <Route path="sessions" element={<Sessions />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
